/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BabylonValidatorVoteInfo = {
    ID: string;
    TTL: string;
    MSGTP: Array<string>;
    TRXHA: string;
    VOTETP: BabylonValidatorVoteInfo.VOTETP;
    STATTP: BabylonValidatorVoteInfo.STATTP;
    AGE: string;
    UT: number;
};

export namespace BabylonValidatorVoteInfo {

    export enum VOTETP {
        YES = 'YES',
        NO = 'NO',
        VETO = 'VETO',
        ABSTAIN = 'ABSTAIN',
        DID_NOT_VOTE = 'DID_NOT_VOTE',
        WEIGHTED = 'WEIGHTED',
    }

    export enum STATTP {
        UNSPECIFIED = 'UNSPECIFIED',
        DEPOSIT_PERIOD = 'DEPOSIT_PERIOD',
        VOTING_PERIOD = 'VOTING_PERIOD',
        PASSED = 'PASSED',
        REJECTED = 'REJECTED',
        FAILED = 'FAILED',
    }


}

